module.exports = __webpack_public_path__ + "static/Akebia-ISR-Proposal-Form-306f96933b06ce05d7f6af86ce24d1a4.pdf";